import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import InputSearch from 'component/utils/InputSearch'
import Field from 'component/utils/Field'

class Title extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dsTilte: '',
    }
  }

  onSubmit = () => {
    const { onSubmit } = this.props
    // event.preventDefault()
    onSubmit()
  }

  handleChange = (event) => {
    const { name, value } = event.target
    this.setState({ [name]: value })
  }

  render() {
    const { visible, translate, handleCollapse, toggleModal } = this.props

    const { dsTilte } = this.state

    return (
      <Row className='padding'>
        <Col
          lgOffset={visible ? 3 : 0}
          mdOffset={visible ? 3 : 0}
          xsOffset={visible ? 6 : 0}
          lg={4}
          md={4}
          xs={visible ? 6 : 12}
          className='margin-top'
        >
          <button
            className={`filter-button title ${visible ? '' : 'margin-left'}`}
            onClick={() => handleCollapse(!visible)}
          >
            <i
              className={`glyph glyph-grey glyph-${
                visible ? 'double-arrow-left' : 'double-arrow-right'
              } icon-size`}
            />
            {translate('label.help.config.filters')}
          </button>
        </Col>

        {!visible && (
          <Col lg={5} md={5} xs={12}>
            <form onSubmit={this.onSubmit}>
              <Field input={{ value: dsTilte }}>
                <InputSearch
                  id='dsTilte'
                  name='dsTilte'
                  className='chat-contact-search width-100'
                  label={translate('label.help.config.search')}
                  value={dsTilte}
                  onChange={this.handleChange}
                  onSubmit={this.onSubmit}
                />
              </Field>
            </form>
          </Col>
        )}

        {!visible && (
          <Col lg={3} md={3} xs={12} className='margin-top'>
            <button
              className='button button-primary button-full'
              onClick={() => {
                toggleModal('HELP_CONFIG_NEW')
              }}
            >
              {translate('buttom.help.config.new')}
            </button>
          </Col>
        )}
      </Row>
    )
  }
}

Title.propTypes = {
  handleCollapse: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  translate: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  toggleModal: PropTypes.func.isRequired,
}

export default Title
